/**
 * @generated SignedSource<<ef0c97b230367d897c92657bff52446a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSummaryItemSkuDetails_item$data = {
  readonly isMultiSku: boolean;
  readonly isRingItem: boolean | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"RingSizeDisplay_item">;
  readonly " $fragmentType": "CheckoutSummaryItemSkuDetails_item";
};
export type CheckoutSummaryItemSkuDetails_item$key = {
  readonly " $data"?: CheckoutSummaryItemSkuDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSummaryItemSkuDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RingSizeDisplay_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "42ca97ee6fcbcca1a1b64dd1c2010ce0";

export default node;
